import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Condiciones",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h3: "h3",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Title} = _components;
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: " Condiciones "
    }), "\n", _jsx(_components.p, {
      children: "El Informe de Seguimiento de la Educación en el Mundo alienta el uso del sitio web del Scoping Progress in Education (SCOPE) únicamente con fines informativos. Todos los contenidos de este sitio web están protegidos por derechos de autor. Al acceder al sitio web y utilizar su contenido, usted (el \"usuario\") reconoce que ha leído y comprendido cabalmente las presentes Condiciones y las acepta."
    }), "\n", _jsxs(_components.p, {
      children: ["La información disponible en este sitio web ha sido publicada con la intención de que esté fácilmente disponible para un uso personal o público con fines no comerciales, y puede ser reproducida, parcial o totalmente, y por cualquier medio, sin costo o sin necesidad de un permiso adicional, a menos que se especifique lo contrario. Todas las solicitudes de uso comercial y derechos de traducción deberán enviarse a ", _jsx(_components.a, {
        href: "mailto:gemreport@unesco.org",
        children: "gemreport@unesco.org"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "los-usuarios-deberán",
      children: "Los usuarios deberán:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "actuar con la diligencia debida para asegurar la exactitud de los elementos reproducidos;"
      }), "\n", _jsx(_components.li, {
        children: "indicar la fuente de manera bien visible junto con los datos empleados de acuerdo con el siguiente formato:"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Source: Fuente: (si procede, \"adaptado de\") Scoping Progress in Education (SCOPE) - Informe GEM, ", _jsx(_components.a, {
        href: "https://www.education-progress.org",
        children: "https://www.education-progress.org"
      }), ", fecha de consulta."]
    }), "\n", _jsx(_components.p, {
      children: "Cabe señalar que la base de datos se actualiza y revisa periódicamente. Por lo tanto, es importante incluir la fecha de consulta al citar los datos."
    }), "\n", _jsx(_components.h3, {
      id: "licencias",
      children: "Licencias"
    }), "\n", _jsx(_components.p, {
      children: "Le recomendamos utilizar los datos en beneficio propio y ajeno de manera creativa. Puede extraer, descargar y copiar la información contenida en los conjuntos de datos, y compartirla con terceros."
    }), "\n", _jsx(_components.h3, {
      id: "ningún-tipo-de-afiliación-ni-respaldo",
      children: "Ningún tipo de afiliación ni respaldo"
    }), "\n", _jsx(_components.p, {
      children: "El usuario no podrá representar el Informe de Seguimiento de la Educación en el Mundo, ni dar a entender que este último ha participado en el uso o reproducción del material por parte del usuario, o los ha aprobado, respaldado o apoyado de cualquier otra manera. El usuario no podrá atribuirse ninguna afiliación con el Progreso de la educación (o con el Informe de Seguimiento de la Educación en el Mundo)."
    }), "\n", _jsx(_components.h3, {
      id: "enlaces-web",
      children: "Enlaces web"
    }), "\n", _jsx(_components.p, {
      children: "Un sitio web externo puede incluir un enlace a cualquier página del sitio web del SCOPE sin solicitar la autorización. Sin embargo, esto no deberá menoscabar los derechos de propiedad intelectual del Informe de Seguimiento de la Educación en el Mundo, en particular en cuanto a los nombres, logotipos o derechos de autor."
    }), "\n", _jsx(_components.h3, {
      id: "descargo-de-responsabilidad",
      children: "Descargo de responsabilidad"
    }), "\n", _jsx(_components.p, {
      children: "El Informe de Seguimiento de la Educación en el Mundo actualiza este sitio web para mejorar el acceso del público a los datos y la información conexa. Hace todo lo posible por velar por la exactitud o exhaustividad de la información de este sitio, aunque no puede garantizarlas. Nuestra meta es presentar información actualizada y precisa. Trataremos de corregir los errores que se nos señalen."
    }), "\n", _jsx(_components.p, {
      children: "Los términos empleados en este sitio web y la presentación del material que figura en él no implican toma alguna de posición de parte de la UNESCO en cuanto al estatuto jurídico de los países, territorios, ciudades o regiones ni respecto de sus autoridades, fronteras o límites."
    }), "\n", _jsx(_components.p, {
      children: "El Equipo del Informe de Seguimiento de la Educación en el Mundo se encarga de elegir y exponer los datos recogidos en este sitio web, que no reflejan necesariamente los puntos de vista de la UNESCO y no comprometen a la Organización."
    }), "\n", _jsx(_components.p, {
      children: "Hacemos todo lo posible por minimizar los fallos causados por errores técnicos. Sin embargo, algunos datos o información del sitio web pueden haber sido creados o estructurados en archivos o formatos que no están exentos de errores, por lo que no podemos garantizar que nuestro servicio no se vea interrumpido o afectado por tales problemas. El Informe de Seguimiento de la Educación en el Mundo no se responsabiliza de estos problemas (fallos de funcionamiento, virus informáticos, cortes de las líneas de comunicación, alteraciones del contenido, etc.) ocasionados por el uso del sitio web del Progreso de la educación o de cualquier enlace a sitios externos."
    }), "\n", _jsx(_components.h3, {
      id: "protección-de-la-vida-privada",
      children: "Protección de la vida privada"
    }), "\n", _jsx(_components.p, {
      children: "Al acceder al sitio web del Progreso de la educación, cierta información, como las direcciones de protocolo Internet (IP), el comportamiento de navegación en el sitio web, el software utilizado y el tiempo de consulta, además de otra información similar, se almacenará en nuestros servidores. Esta información no permitirá que se le identifique, sino que se utilizará para analizar el tráfico web."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
